import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Slide from "@mui/material/Slide";
import { TransitionProps } from "@mui/material/transitions";
import React, { useEffect, useRef, useState } from "react";
import { statusForBtnsRequestModel } from "../../../api/apiRequestObjects";
import apis from "../../../api/apis";
import { APIResponseType } from "../../../config/enumApiResponseTypes";
import {
  ICancelOrDenyReasonForOrder,
  IPartnerOrder,
} from "../../../interfaces/order";
import { useSelector } from "react-redux";

interface IProps {
  openReasonDialog: boolean;
  isReasonForReject: boolean;
  selectedReasonCode: string;
  reasonStateKey: number;
  selectedOrder: IPartnerOrder;
  handleRadioBtnChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleClickOKReasonDialog: (orderStatesKey: number) => void;
  handleDialogClose: () => void;
}

//mui transition function for reason dialog
const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const CancelRejectReasonDialog: React.FC<IProps> = ({
  openReasonDialog,
  isReasonForReject,
  selectedReasonCode,
  selectedOrder,
  reasonStateKey,
  handleRadioBtnChange,
  handleClickOKReasonDialog,
  handleDialogClose,
}) => {
  /*   const [cancelReasons, setCancelReasons] = useState<
    ICancelOrDenyReasonForOrder[]
  >([]); */
  const [denyOrCancelReasons, setDenyReasons] = useState<
    ICancelOrDenyReasonForOrder[]
  >([]);
  //const [isReasonForReject, setIsReasonForReject] = useState(false);
  const componentMounted = useRef(true);
  //get redux state
  const { user } = useSelector((state: any) => state.authentication);

  //fetch Deny or Cancel Reasons for Dialog
  useEffect(() => {
    const fetchDenyOrCancelReasonData = async () => {
      try {
        statusForBtnsRequestModel.UID.UserKey = user.UserKey;
        statusForBtnsRequestModel.UID.LocationKey = user.LocationKey;
        statusForBtnsRequestModel.UID.CompanyKey = user.CompanyKey;
        statusForBtnsRequestModel.UID.EnvironmentName = user.EnvironmentName;
        statusForBtnsRequestModel.UID.IsUrbanPiper = user.IsUrbanPiper;

        statusForBtnsRequestModel.OrderTypeKey =
          selectedOrder.OrderDelivery.TypeOfOrder.OrderTypeId;

        if (statusForBtnsRequestModel.OrderTypeKey > 0) {
          const response = await apis.Orders.fetchCancelDenyReasonCodes(
            statusForBtnsRequestModel
          );
          if (response.ResponseType === APIResponseType.Success) {
            const rejectReasons = {};

            /*             const jwtToken = jwt.sign(
              response.ResponseData.CancelOrDenyReasonList,
              SECRET_KEY
            ); */

            /* localStorage.setItem("Deny_Reasons", jwtToken); */
            setDenyReasons(response.ResponseData.CancelOrDenyReasonList);
          } else {
            console.log("api fetching error");
          }
        }
      } catch (e) {
        console.log(e);
      }
    };

    if (localStorage.getItem("Deny_Reasons")) {
      const denyReasonsToken = localStorage.getItem("Deny_Reasons");
      //console.log(JSON.parse(denyReasonsToken!.split(".")[1]));
      setDenyReasons(JSON.parse(denyReasonsToken!.split(".")[1]));
    } else {
      fetchDenyOrCancelReasonData();
      //console.log("fetching run");
    }
    return () => {
      // This code runs when component is unmounted
      componentMounted.current = false;
    };
  }, [
    selectedOrder.OrderDelivery.TypeOfOrder.OrderTypeId,
    user.CompanyKey,
    user.EnvironmentName,
    user.LocationKey,
    user.UserKey,
  ]);

  return (
    <>
      <Dialog
        open={openReasonDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleDialogClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Choose a Reason to Cancel/Reject Order :"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <FormControl component="fieldset">
              <FormLabel component="legend">Reasons</FormLabel>
              <RadioGroup
                aria-label="Reasons"
                name="radio-buttons-group"
                onChange={handleRadioBtnChange}
              >
                {denyOrCancelReasons &&
                  denyOrCancelReasons
                    .filter((x) => x.OrderStatusKey === reasonStateKey)
                    .map((reason) => (
                      <FormControlLabel
                        name={reason.ReasonKey.toString()}
                        value={reason.Code}
                        control={<Radio />}
                        label={reason.ReasonName}
                      />
                    ))}
              </RadioGroup>
            </FormControl>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDialogClose}>Cancel</Button>
          <Button
            variant="outlined"
            onClick={() => handleClickOKReasonDialog(reasonStateKey)}
            disabled={selectedReasonCode !== "" ? false : true}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CancelRejectReasonDialog;
